var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"block",on:{"click":_vm.toggle}},[(_vm.client.starredTab === _vm.tabId)?_c('b-icon-star-fill',{staticClass:"icon",attrs:{"variant":"warning"}}):_c('b-icon-star',{staticClass:"icon"}),(_vm.processing)?_c('span',{staticClass:"mask"},[_c('b-spinner',{staticClass:"centered-spinner",attrs:{"variant":"primary"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }